import Vue from "vue";
import Vuex from "vuex";
import Menu from "./menu";
import Tasya from "./tasya";
import modules from "./modules";
import {
  SET_LOADING_FALSE,
  SET_LOADING_TRUE,
  SET_POPUP_LOGIN_TRUE,
  SET_POPUP_LOGIN_FALSE,
} from "./constants";

Vue.use(Vuex);

const baseUrl = process.env.VUE_APP_API_URL;
const baseUrlAdiraku = process.env.VUE_APP_ADIRAKU_URL;

export default new Vuex.Store({
  state: {
    menu: Menu,
    tasya: Tasya,
    simulation_base_url: `${baseUrl}/v3/simulation/api`,
    post_grab_kode: `${baseUrl}/v3/orderin/channelCode`,
    post_form_grab: `${baseUrl}/v3/transaction/transactions`,
    bo_base_url: `${baseUrl}/v3/branch-office`,
    base_url: `${baseUrl}/v3/branch-office`,
    base_url_bffjava: `${baseUrl}/v3/bffnew`,
    base_url_bff: `${baseUrl}/v3/bff`,
    base_url_mpl_order: `${baseUrl}/v3/ms-mpl-order`,
    base_url_momobil_partner: `${baseUrlAdiraku}/momobil/v1/partner`,
    base_url_dbank: "*",
    loading: false,
    popuplogin: false,
    kode_Grab: "",
  },

  mutations: {
    [SET_LOADING_FALSE](state) {
      state.loading = false;
    },
    [SET_LOADING_TRUE](state) {
      state.loading = true;
    },
    [SET_POPUP_LOGIN_TRUE](state) {
      state.popuplogin = true;
    },
    [SET_POPUP_LOGIN_FALSE](state) {
      state.popuplogin = false;
    },
    SET_KODE(state, payload) {
      state.kode_Grab = payload;
    },
  },

  getters: {
    getApiBaseURL: (state) => state.base_url,
    isLoading: (state) => state.loading,
    isPopuplogin: (state) => state.popuplogin,
    getKodeGrab: (state) => state.kode_Grab,
  },

  actions: {
    setLoadingTrue({ commit }) {
      commit(SET_LOADING_TRUE);
    },
    setLoadingFalse({ commit }) {
      commit(SET_LOADING_FALSE);
    },
    setPopupLoginTrue({ commit }) {
      commit(SET_POPUP_LOGIN_TRUE);
    },
    setPopupLoginFalse({ commit }) {
      commit(SET_POPUP_LOGIN_FALSE);
    },
    setKode(context, number) {
      context.commit("SET_KODE", number);
    },
  },

  modules,
});
